import React from "react";


const Spinner = () => (
  <>
  <svg className="jg-spinner" width="120" height="120" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFA500" />
        <stop offset="100%" stopColor="#FF4500" />
      </linearGradient>
    </defs>

    <g className="spinner-rays" stroke="orange" strokeWidth="4" strokeLinecap="round">
      <line x1="60" y1="10" x2="60" y2="0" />
      <line x1="60" y1="110" x2="60" y2="120" />
      <line x1="10" y1="60" x2="0" y2="60" />
      <line x1="110" y1="60" x2="120" y2="60" />
      <line x1="90" y1="20" x2="95" y2="15" />
      <line x1="30" y1="100" x2="25" y2="105" />
      <line x1="100" y1="90" x2="105" y2="95" />
      <line x1="20" y1="30" x2="15" y2="25" />
    </g>

    <text x="60" y="70" textAnchor="middle" fontSize="32" fontWeight="bold" fill="url(#grad)">
      JG
    </text>
  </svg>
  <style>
        {`
          

.spinner-rays {
  transform-origin: 60px 60px;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

        `}
      </style>
  </>

  
);

export default Spinner;
